const dataAccessMethods = require('../../../dataAccessMethods');
const { config } = require('@sstdev/lib_metadata-config');
const Blockly = require('blockly');
const DelegatingMdcBlockGroup = require('../_DelegatingMdcBlockGroup');
const hNodeTypes = require('./types');
const {convertToBoolean} = require('../../../helpers');

class DetailPane extends DelegatingMdcBlockGroup {
    constructor(hNodeTypeGroup, categorySpec, color, subset = '') {
        super(hNodeTypeGroup, categorySpec, color, subset);
        super.types = hNodeTypes;
    }

    addCodeGeneratorCustom(code, blocklyBlock) {
        let dropdownForAction = blocklyBlock.getFieldValue('forAction');
        let dropdownNamespace = blocklyBlock.getFieldValue('namespace');
        let dropdownRelation = blocklyBlock.getFieldValue('relation');
        let autoRefresh = convertToBoolean(blocklyBlock.getFieldValue('autoRefresh'));
        code.showForAction = dropdownForAction;
        code.namespace = dropdownNamespace;
        code.relation = dropdownRelation;
        code.autoRefresh = autoRefresh;
        return JSON.stringify(code);
    }

    addToBlocksCustom(color, blocklyBlock, hNodeType, mdcBlock) {
        blocklyBlock
            .appendDummyInput()
            .setAlign(Blockly.ALIGN_RIGHT)
            .appendField('  Namespace:')
            .appendField(new Blockly.FieldDropdown(dataAccessMethods.getNamespaces), 'namespace');
        let blockId = blocklyBlock.id;
        let workspace = blocklyBlock.workspace;
        blocklyBlock
            .appendDummyInput()
            .setAlign(Blockly.ALIGN_RIGHT)
            .appendField('  Relation:')
            .appendField(new Blockly.FieldDropdown(() => dataAccessMethods.getRelations(workspace, blockId)), 'relation');
        blocklyBlock
            .appendDummyInput()
            .setAlign(Blockly.ALIGN_RIGHT)
            .appendField('  For Action:')
            .appendField(new Blockly.FieldDropdown(config.formActions), 'forAction');
        blocklyBlock
            .appendDummyInput()
            .setAlign(Blockly.ALIGN_RIGHT)
            .appendField(' Auto Refresh:')
            .appendField(new Blockly.FieldCheckbox('false'), 'autoRefresh');
        blocklyBlock
            .appendStatementInput('children')
            .setCheck(mdcBlock.allowedChildrenTypes)
            .appendField('Children:', 'childrenField');
    }
}

module.exports = DetailPane;
